import React, { useEffect, useState } from "react";
import OrdersTable from "@/app/event_site/billing/items/sections/OrdersTable";
import WaitingListCounters from "@/app/event_site/billing/items/sections/WaitingListCounters";
import useDebounce from "@/app/event_site/billing/items/sections/hooks/useDebounce";
import { service } from 'services/service';
import Loader from '@/app/forms/Loader';
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import in_array from "in_array";
import { getNextBillingNavigation } from '../../../../../utils/navigationUtils';
 
const WaitingListOrders = (props) =>
{

	const navigate = useNavigate();

	const url = process.env.REACT_APP_URL
	const path = "/billing/waiting-list-orders"
	const [orders, setOrders] = useState([])
	const [state, setState] = useState({})
	const initialState = {
		remainingTickets: 0,
		pendingTickets: 0,
		sentOffers: 0,
		confirmedAttendees: 0,
		notInterested: 0
	}
	const module_routes = {
		"attendees": "/event/module/attendees",
		"agendas": "/event/module/programs",
		"speakers": "/event/module/speakers",
		"infobooth": "/event/module/practical-information",
		"additional_info": "/event/module/additional-information",
		"general_info": "/event/module/general-information",
		"maps": "/event/module/map",
		"subregistration": "/event/module/sub-registration",
		"ddirectory": "/event/module/documents"
	}
	const [eventTicketsCounters, setEventTicketsCounters] = useState(initialState)
	const [isLargeScreen, setIsLargeScreen] = useState(false)
	const [searchQuery, setSearchQuery] = useState("")
	const [debouncedSearchQuery] = useDebounce(searchQuery, 500)
	const [statusFilter, setStatusFilter] = useState("all")
	const [isLoading, setIsLoading] = useState(false)
	const [displayPanel] = useState(true)
	const [nextPreviousState, setNextPreviousState] = useState({
		next: "",
		prev: ""
	})
	const [pagination, setPagination] = useState({
		limit: 10,
		total: '',
		from: 0,
		to: 0,
		activePage: 1,
		order_by: 'ASC',
		sort_by: 'order_date'
	})
	
	// Menu hierarchy for dynamic navigation
	const [menuHierarchy, setMenuHierarchy] = useState([])

	// Fetch menu hierarchy on mount or when the event changes
	useEffect(() => {
		fetchMenuHierarchy();
	}, [props.event]);

	// Fetch data and compute next/prev when the search query or menuHierarchy changes
	useEffect(() => {
		const init = async () => {
			try {
				await getWaitingListOrdersData();
			} catch (error) {
				console.log(error);
			}
			handleNextPrevButtons();
		};

		init();
	}, [debouncedSearchQuery, statusFilter, menuHierarchy, props.event]);

	// Fetch menu hierarchy for dynamic navigation
	const fetchMenuHierarchy = async () => {
		const eventId = props.event && props.event.id ? props.event.id : localStorage.getItem('event_id');
		if (!eventId) {
			console.log('Navigation Debug - No event ID found');
			return;
		}

		try {
			// Import EventService dynamically to avoid circular dependency
			const module = await import('services/event/event-service');
			const { EventService } = module;
			const response = await EventService.getMenuHierarchy(eventId);
			
			if (response.success) {
				console.log('Menu Hierarchy loaded for WaitingListOrders:', response.data);
				setMenuHierarchy(response.data);
			}
		} catch (error) {
			console.error('Error fetching menu hierarchy:', error);
		}
	};

	// Handle next/previous navigation with dynamic logic
	const handleNextPrevButtons = () => {
		const event = props.event;
		if (event && event.modules !== undefined && event.modules.length > 0 && Number(event.is_registration) === 0 && Number(event.is_app) === 0) {
			let modules = event.modules.filter(function (module, i) {
				return ((!in_array(module.alias, ["polls"]) && Number(module.status) === 1) || (in_array(module.alias, ["subregistration"])));
			});

			// Debug info: log modules and menuHierarchy
			console.log('Navigation Debug - event.modules (filtered):', modules.map(m => ({ alias: m.alias, status: m.status })));
			console.log('Navigation Debug - menuHierarchy:', menuHierarchy);

			// Use dynamic navigation instead of hardcoded routes
			const nextNav = getNextBillingNavigation('waiting_list_orders', menuHierarchy);
			console.log('Navigation Debug - getNextBillingNavigation result:', nextNav);

			const fallbackNext = (modules[0] !== undefined && module_routes[modules[0]['alias']] !== undefined ? module_routes[modules[0]['alias']] : "/event/manage/surveys");
			console.log('Navigation Debug - computed fallbackNext:', fallbackNext);

			if (nextNav && nextNav.route) {
				console.log('Navigation Debug - Next route found (using dynamic):', nextNav.route);
				setNextPreviousState({ next: nextNav.route, prev: "/event_site/billing-module/manage-orders" });
			} else {
				console.log('Navigation Debug - No dynamic next route found, using fallback');
				setNextPreviousState({ next: fallbackNext, prev: "/event_site/billing-module/manage-orders" });
			}
		}
	};

	//make api call to fetch the data for the
	//waiting list orders/attendees
	async function getWaitingListOrdersData()
	{
		const currentPage = pagination.activePage ? pagination.activePage : 1
		setIsLoading(true)
		try
		{
			const response = await service.post(url + path + "/" + currentPage, {
				...pagination,
				query: debouncedSearchQuery || '',
				attendee_status: statusFilter || 'all',
				payment_status: '',
			})

			if (response)
			{
				console.log(response)
				setEventTicketsCounters({
					remainingTickets: response.remaining_tickets,
					pendingTickets: response.pending_tickets,
					sentOffers: response.offer_letters,
					confirmedAttendees: response.confirmed_attendees,
					notInterested: response.not_interested
				})

				setOrders(response.waitingListOrders.data)
				setState(response)
				setIsLoading(false)

				setPagination(prevState => ({
					...prevState,
					activePage: response.waitingListOrders.current_page,
					total: response.waitingListOrders.total,
					from: response.waitingListOrders.from,
					to: response.waitingListOrders.to,
				}))

			}
		} catch (error)
		{
			setIsLoading(false)
			console.log(error)
		}
	}

	//toggle large screen
	function handleLargeScreen()
	{
		setIsLargeScreen(prevState => !prevState)
	}

	//render content
	function showContent(t)
	{
		return (
				<React.Fragment>
					<div style={{ height: "100%" }}>
							<WaitingListCounters remainingTickets={eventTicketsCounters.remainingTickets}
								pendingTickets={eventTicketsCounters.pendingTickets}
								sentOffers={eventTicketsCounters.sentOffers}
								confirmedAttendees={eventTicketsCounters.confirmedAttendees}
								notInterested={eventTicketsCounters.notInterested}
								orders={orders} setOrders={setOrders} state={state} />
							{!isLoading ?
									<OrdersTable orders={orders}
										isLargeScreen={isLargeScreen}
										handleLargeScreen={handleLargeScreen}
										setSearchQuery={setSearchQuery}
										searchQuery={searchQuery}
										statusFilter={statusFilter}
										setStatusFilter={setStatusFilter}
										getWaitingListOrdersData={getWaitingListOrdersData}
										pagination={pagination} setPagination={setPagination} isLoading={isLoading} setIsLoading={setIsLoading} />
									:
									<Loader />
							}
					</div>
					{showBottomPanel(t)}
				</React.Fragment>
		)
	}

	function showBottomPanel(t)
	{
		return (
			<React.Fragment>
				{
					displayPanel && (
						<div className="bottom-component-panel clearfix">
							{!isLargeScreen ? (
								<React.Fragment>
									<NavLink
										target="_blank"
										className="btn btn-preview float-left"
										to={`/event/preview`}
									>
										<i className="material-symbols-outlined">remove_red_eye</i>
										{t("G_PREVIEW")}
									</NavLink>
									{nextPreviousState.prev !== undefined && (
										<NavLink className="btn btn-prev-step" to={nextPreviousState.prev}>
											<span className="material-symbols-outlined">keyboard_backspace</span>
										</NavLink>
									)}
									{nextPreviousState.next !== undefined && (
										<button
											className="btn btn-next-step"
											onClick={() => {
												console.log('Navigation Click - Next (button):', nextPreviousState.next, 'menuHierarchy snapshot:', menuHierarchy);
												let route = nextPreviousState.next;
												// If state is empty, compute fresh using navigation util
												if (!route || route === '' || route === '/') {
													const nextNav = getNextBillingNavigation('waiting_list_orders', menuHierarchy);
													console.log('Navigation Click - computed nextNav at click:', nextNav);
													if (nextNav && nextNav.route) {
														route = nextNav.route;
													} else {
														// compute fallback using props.event modules
														const event = props.event;
														let modules = [];
														if (event && event.modules && event.modules.length > 0) {
															modules = event.modules.filter(function (module, i) {
																return ((!in_array(module.alias, ["polls"]) && Number(module.status) === 1) || (in_array(module.alias, ["subregistration"])));
															});
														}
														const fallbackNext = (modules[0] !== undefined && module_routes[modules[0]['alias']] !== undefined ? module_routes[modules[0]['alias']] : "/event/manage/surveys");
														console.log('Navigation Click - computed fallbackNext at click:', fallbackNext);
														route = fallbackNext;
													}
												}
												if (route && route !== '' && typeof route === 'string' && route !== '/') {
													navigate(route);
												} else {
													console.warn('Navigation blocked - invalid or empty route after compute:', route);
												}
											}}
										>
											{t("G_NEXT")}
										</button>
									)}
								</React.Fragment>
							) : (
								<button className="btn btn-save-next" onClick={handleLargeScreen}>{t('G_CLOSE')}
								</button>
							)}
						</div>
					)
				}
			</React.Fragment>
		)
	}

	return (
		<React.Fragment>
			<div className="wrapper-content third-step">
				<Translation>
					{t => (
						<React.Fragment>
							{isLargeScreen === true ?
								<div className="wrapper-import-file-wrapper">
									<div className="wrapper-import-file inline-popup-records">
										<div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
											<div className="top-popuparea">
												{showContent(t)}
											</div>
										</div>
									</div>
								</div>
								:
								showContent(t)
							}
						</React.Fragment>
						)
					}
				</Translation>
			</div>
		</React.Fragment>
	)
}

//state is redux state
function mapStateToProps(state)
{
	const { event, update } = state
	return { event, update }
}

export default connect(mapStateToProps)(WaitingListOrders)
